import { render } from "./SubmissionsListWindow.vue?vue&type=template&id=63af05f2&scoped=true"
import script from "./SubmissionsListWindow.vue?vue&type=script&lang=js"
export * from "./SubmissionsListWindow.vue?vue&type=script&lang=js"

import "./SubmissionsListWindow.vue?vue&type=style&index=0&id=63af05f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63af05f2"]])

export default __exports__